// Answering a task's approval from this browser (D85): the same signed request the apps send
// (`POST /api/tasks/{id}/approval`, payload `{node_id, answer}`), signed with this browser's
// authentication key so the decision is bound to one of the owner's devices.
import { api } from "../../api/client";
import { unwrap } from "../../api/queries";
import type { Proto } from "../../proto/index";
import { signedBody } from "../../secrets/requests";
import type { LinkedDevice } from "../../device/store";

export async function answerApproval(proto: Proto, device: LinkedDevice, taskId: string, node: string, answer: string): Promise<void> {
  const signer = { proto, deviceId: device.deviceId, key: device.keys.auth.privateKey };
  const path = `/api/tasks/${taskId}/approval`;
  const body = await signedBody(signer, "POST", path, { node_id: node, answer });
  await unwrap(api.POST("/api/tasks/{task_id}/approval", { params: { path: { task_id: taskId } }, body }));
}
